var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _path9, _path10, _rect3, _rect4, _rect5, _rect6, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcPowerManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 78,
    viewBox: "0 0 83 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 4.5L41.5 8.5L41 5.5L43 4.5L39.5 0.5L41 4L39.5 4.5Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 38.1758,
    width: 82.2174,
    height: 39.4643,
    fill: "url(#paint0_linear_2_13514)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1548 2H69.0626L82.2174 38.1757H0L13.1548 2Z",
    fill: "url(#paint1_linear_2_13514)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5308 25.5689L40.56 16.251L47.6855 25.5689H34.5308Z",
    fill: "#FFCE70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.5308 25.5693H47.6855",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M0 38.7236H82.2174",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M0 77.0918H82.2174",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M81.6697 39.2715V77.6396",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M0.547607 39.2715V77.6396",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 13.1545,
    y: 43.6572,
    width: 55.9078,
    height: 14.251,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.636 49.8695C18.636 49.4659 18.9632 49.1387 19.3668 49.1387H26.675V53.5236H19.3668C18.9632 53.5236 18.636 53.1964 18.636 52.7928V49.8695Z",
    fill: "#2FD60A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5408 49.869C17.5408 48.86 18.3588 48.042 19.3678 48.042H29.5993C30.6084 48.042 31.4264 48.86 31.4264 49.869V52.7923C31.4264 53.8014 30.6084 54.6194 29.5993 54.6194H19.3678C18.3588 54.6194 17.5408 53.8014 17.5408 52.7923V49.869ZM19.3678 48.7728C18.7624 48.7728 18.2716 49.2636 18.2716 49.869V52.7923C18.2716 53.3978 18.7624 53.8886 19.3678 53.8886H29.5993C30.2048 53.8886 30.6956 53.3978 30.6956 52.7923V49.869C30.6956 49.2636 30.2048 48.7728 29.5993 48.7728H19.3678Z",
    fill: "#2FD60A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3679,
    y: 46.9453,
    width: 1.09623,
    height: 1.09623,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3679,
    y: 49.1377,
    width: 1.09623,
    height: 1.09623,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3679,
    y: 51.3301,
    width: 1.09623,
    height: 1.09623,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3679,
    y: 53.5225,
    width: 1.09623,
    height: 1.09623,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.2259,
    cy: 47.494,
    r: 1.64435,
    fill: "#FF4949"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.79297,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.61133,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4299,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2485,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0684,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8879,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7065,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5251,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3438,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1624,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9807,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8005,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6204,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.439,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2573,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.0759,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8945,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7131,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.533,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3513,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1711,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.9897,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.8096,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6267,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4453,
    y: 63.7021,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.79297,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.61133,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4299,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2485,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0684,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8879,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7065,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5251,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3438,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1624,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9807,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8005,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6204,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.439,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2573,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.0759,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8945,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7131,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.533,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3513,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1711,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.9897,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.8096,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6267,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4453,
    y: 69.3398,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.79297,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.61133,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4299,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2485,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0684,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8879,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7065,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5251,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3438,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1624,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9807,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8005,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6204,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.439,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2573,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.0759,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8945,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7131,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.533,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.3513,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1711,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.9897,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.8096,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6267,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4453,
    y: 66.5215,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.38477,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.20337,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.022,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8416,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6614,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.48,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2986,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1172,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9355,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7542,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5728,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.3926,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2122,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0308,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.8494,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.668,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4866,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3049,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1248,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.9446,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7632,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5815,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4014,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2188,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.0374,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8569,
    y: 62.293,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.38477,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.20337,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.022,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8416,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6614,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.48,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2986,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1172,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9355,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7542,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5728,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.3926,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2122,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0308,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.8494,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.668,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4866,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3049,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1248,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.9446,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7632,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5815,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4014,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2188,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.0374,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8569,
    y: 70.75,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.38477,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.20337,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.022,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8416,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6614,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.48,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2986,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1172,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9355,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7542,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5728,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.3926,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2122,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0308,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.8494,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.668,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4866,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3049,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1248,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.9446,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7632,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5815,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4014,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2188,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.0374,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8569,
    y: 65.1113,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.38477,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.20337,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.022,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8416,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6614,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.48,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2986,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1172,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9355,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7542,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5728,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.3926,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2122,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0308,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.8494,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.668,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4866,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3049,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1248,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.9446,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7632,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5815,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4014,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2188,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.0374,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8569,
    y: 67.9307,
    width: 1.40944,
    height: 1.40944,
    fill: "#18171E"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.205 20.0883L41.3668 23.6597L39.677 22.5332L38.3682 23.9251L37.8779 23.68L39.2518 20.9322L40.8507 21.9981L41.6961 19.8848L42.205 20.0883Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_13514",
    x1: 76.7362,
    y1: 38.1758,
    x2: 7.67362,
    y2: 77.6401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_13514",
    x1: 41.1087,
    y1: 2,
    x2: 41.1087,
    y2: 38.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F475E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcPowerManagement);
export default __webpack_public_path__ + "static/media/ACPowerManagement.4c75a0a37c337e532c1333133adc2713.svg";
export { ForwardRef as ReactComponent };